export const PmStateMap = {
    idle: "idle",
    pending: "pending",
    resolve: "resolve",
    reject: "reject"
};

/// promise状态绑定混合类
export const PmStateMixin = {
    methods: {
        /**
         * 包装 promise，将 promise 状态绑定到 data 中
         * @param promise promise对象
         * @param key 要绑定的 data key。与 vue watch 类似，支持深度绑定，如 "form.loading"
         * @returns Promise
         */
        wrapPromiseState(promise, key) {
            console.assert(key !== "" && key != null, "key的值不能为空");
            this._setDeepData(key, PmStateMap.pending);
            return promise.then((res) => {
                this._setDeepData(key, PmStateMap.resolve);
                return res;
            }).catch(error => {
                console.error(error);
                this._setDeepData(key, PmStateMap.reject);
                return Promise.reject(error);
            });
        },
        /**
         * 包装 promise，将进行中状态绑定到 data 中
         * @param promise
         * @param key
         * @returns Promise
         */
        wrapPromising(promise, key = "loading") {
            this._setDeepData(key, true);
            return promise.finally(() => {
                this._setDeepData(key, false);
            });
        },
        _setDeepData(dataKey, data) {
            const notUndefined = (obj, index) => {
                if (obj == null) {
                    const joined = dPath.slice(0, index).join(".");
                    const msg = `vm.$data.${dataKey} 中的 ${joined} 不存在 ${dPath[index]}`;
                    throw new Error(msg);
                }
            };
            const beObject = (obj, index) => {
                if (typeof rootObj !== "object") {
                    const joined = dPath.slice(0, index + 1).join(".");
                    const msg = `vm.$data.${dataKey} 中的 ${joined} 不为 Object`
                    throw new Error(msg);
                }
            };

            let dPath = dataKey.split(".");
            let rootObj = this.$data;
            dPath.forEach((subKey, index) => {
                if (index === dPath.length - 1) {
                    this.$set(rootObj, subKey, data);
                } else {
                    rootObj = rootObj[subKey];
                    notUndefined(rootObj, index);
                    beObject(rootObj, index)
                }
            });
        }
    },
    computed: {
        pmStateMap() {
            return PmStateMap;
        }
    }
}
